import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M21 13C20.447 13 20 13.447 20 14V17C20 17.552 19.552 18 19 18H5C4.449 18 4 17.552 4 17V7C4 6.449 4.449 6 5 6H12C12.552 6 13 5.552 13 5C13 4.448 12.552 4 12 4H5C3.346 4 2 5.346 2 7V17C2 18.654 3.346 20 5 20H19C20.654 20 22 18.654 22 17V14C22 13.447 21.553 13 21 13Z"
      fill="currentColor"
    />
    <path
      d="M22 4.995V4H16C15.447 4 15 4.448 15 5C15 5.552 15.447 6 16 6H18.587L13.586 11H10C9.448 11 9 11.448 9 12C9 12.552 9.448 13 10 13H14C14.266 13 14.52 12.895 14.707 12.707L20 7.415V10C20 10.552 20.447 11 21 11C21.553 11 22 10.552 22 10V5.005C22 5.002 22 4.999 22 4.995Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'NewWindow');

export default Icon;
